import api from '@services/api'

export default {
  get(axios, params, query, config) {
    return api.get(axios, '/manager/accounts/:account_id/profile', params, query, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/manager/accounts/:account_id/profile', params, payload, config)
  },
}
